import { render, staticRenderFns } from "./TaskStats.vue?vue&type=template&id=5890b5f9"
import script from "./TaskStats.vue?vue&type=script&lang=js"
export * from "./TaskStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports